import { useState } from 'react';
import { format } from 'date-fns'
// @mui
import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Stack,
  Typography,
} from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers-pro';
// components
import { CompanyAvatar } from '../company';


export default function TodoAddDialog({ isOpen, closeDialog, add, isSubmitting}) {
  const [todoContent, setTodoContent] = useState('');
  const [todoContentError, setTodoContentError] = useState(false);
  const [targetDate, setTargetDate] = useState(null);
  const [targetDateError, setTargetDateError] = useState(false);


  const handleTodoContent = (e) => {
    setTodoContentError(!e.target.value);
    setTodoContent(e.target.value);
  }

  const handleTargetDate = (newValue) => {
    setTargetDateError(!newValue);
    setTargetDate(newValue);
  }

  const close = async () => {
    setTodoContent('');
    setTargetDate(null);
    setTodoContentError(false);
    setTargetDateError(false);
    closeDialog();
  }

  const addTodo = async () => {
    if (!todoContent) {
      setTodoContentError(true);
      return;
    }
    if (!targetDate) {
      setTargetDateError(true);
    }
    try {
      const formattedTargetDate = format(targetDate, 'yyyy-MM-dd');
      await add(todoContent, formattedTargetDate);
      close();
    } catch (error) {
      setTargetDateError(true);
    }
  }

  return (
    <Dialog open={isOpen} fullWidth maxWidth="xs">
      <DialogTitle sx={{ mb: 3 }}>
        투두를 추가할까요?
      </DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        <Stack spacing={1} sx={{ width: 1 }}>
          <Typography variant="subtitle2">
            업무를 한 줄로 적어주세요
          </Typography>
          <TextField
            fullWidth
            multiline
            value={todoContent}
            error={todoContentError}
            helperText={todoContentError ? '내용을 입력해주세요' : ''}
            onChange={handleTodoContent}
          />
        </Stack>

        <Stack spacing={1} sx={{ width: 1, mt: 3 }}>
          <Typography variant="subtitle2">
            완료해야 할 날짜를 설정해주세요
          </Typography>
          <DatePicker
            inputFormat="yyyy-MM-dd"
            disablePast
            mask={"____-__-__"}
            value={targetDate}
            onChange={handleTargetDate}
            renderInput={(params) => (
              <TextField {...params} error={targetDateError} helperText={targetDateError ? '날짜를 선택해주세요' : ''} fullWidth />
            )}
          />
        </Stack>

        <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2, mb: {xs: 0, sm: 3} }}>
          <CompanyAvatar nameVariant={"body2"} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          size="large"
          sx={{ px: 3 }}
          loading={isSubmitting}
          onClick={close}
        >
          취소
        </LoadingButton>
        <LoadingButton
          size="large"
          sx={{ px: 3 }}
          loading={isSubmitting}
          variant="contained"
          onClick={addTodo}
        >
          추가하기
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}